import { ToastOptions } from '@ionic/core/components';
import { useIonToast } from '@ionic/react';
import { close } from 'ionicons/icons';
import { useCallback } from 'react';

export default function useToast() {
  const [showIonToast] = useIonToast();

  return useCallback(
    (message: string, duration = 4000, options: ToastOptions = {}) =>
      showIonToast({
        message,
        duration,
        buttons: [
          {
            role: 'Cancel',
            icon: close,
          },
        ],
        color: 'dark',
        ...options,
      }),
    [showIonToast]
  );
}
